import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/Service/auth.service';
import { GlobalConstants } from 'src/app/utils/global-constants';

@Component({
    selector: 'app-newslatterspopup',
    templateUrl: './newslatterspopup.component.html',
    styleUrls: ['./newslatterspopup.component.css'],
    standalone: false
})
export class NewslatterspopupComponent {
  successpopup: boolean;
  mainpopup: boolean = true;

  constructor(public dialog: NgbModal, public auth: AuthService) {}

  submitform = new FormGroup({
    firstname: new FormControl('', [
      Validators.required,
      Validators.pattern(GlobalConstants.firstnamePattern),
    ]),
    lastname: new FormControl('', [
      Validators.required,
      Validators.pattern(GlobalConstants.firstnamePattern),
    ]),
    email: new FormControl('', [
      Validators.required,
      Validators.pattern(GlobalConstants.emailPattern),
    ]),
  });

  submit() {
    if (this.submitform.valid) {
      const data = {
        firstname: this.submitform.value.firstname,
        lastname: this.submitform.value.lastname,
        email: this.submitform.value.email,
      };
      this.auth.NewsLetterUserSignUp(data).subscribe((response) => {
        if (response?.succeeded) {
          this.mainpopup = false;
          this.successpopup = response?.succeeded;
        } else {
          this.mainpopup = true;
        }
      });
    }
  }
}
